import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { BehaviorSubject, firstValueFrom, Subject, Subscription } from 'rxjs';
import { CustomModalComponent } from 'src/app/components/custom-modal/custom-modal.component';
import { CustomTableSelectComponent } from 'src/app/components/custom-table-select/custom-table-select.component';
import { QuotationTypesEnums } from 'src/app/enum/quotation-enums';
import { ActionColor, CheckBoxAction, TableAction } from 'src/app/interfaces/custom-table/custom-table-action.interface';
import { UserModel } from 'src/app/models/authentication/user.model';
import { BreakdownModel } from 'src/app/models/preliminaries/breakdown-model';
import { QuotationDetailModel } from 'src/app/models/preliminaries/quotation-detail.model';
import { QuotationModel } from 'src/app/models/preliminaries/quotation.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { QuotationBreakdownCaptureTableModel } from 'src/app/models/tables/preliminaries/quotation-breakdown-capture-table.model';
import { PriceListDetailService } from 'src/app/services/archive/price-list-detail.service';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';
import { BreakdownService } from 'src/app/services/preliminaries/breakdown.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import { ApplyDiscountBreakdownComponent } from '../apply-discount-breakdown/apply-discount-breakdown.component';
import { DistributeTotalValueBreakdownComponent } from '../distribute-total-value-breakdown/distribute-total-value-breakdown.component';

@Component({
  selector: 'app-breakdown',
  templateUrl: './breakdown.component.html',
  styleUrls: ['./breakdown.component.scss'],
  standalone: false
})
export class BreakdownComponent implements OnInit {

  @ViewChild('articleSelection') articleSelectionModalComponent?: CustomModalComponent | null = null;
  @ViewChild('applyDiscount') applyDiscountModalComponent?: CustomModalComponent | null = null;
  @ViewChild('distributeTotalValue') distributeTotalValueModalComponent?: CustomModalComponent | null = null;

  @Input() userAuthenticated: UserModel = new UserModel();
  @Input('quotationSolution')
  set changeQuotationSolution(changeSolution: QuotationDetailModel) {
    this.changeSolution(changeSolution);
  }
  @Input('quotation')
  set changeQuotationHeader(quotation: QuotationModel) {
    this.changeQuotation(quotation);
  }

  @Input('disableButtons')
  set change(disable: boolean) {
    this.changeVersionState(disable);
  }

  @Input('reloadList')
  set reloadList(reload: boolean) {
    if (reload) {
      this.getAllBreakdownsByQuotationSolution();
    }
  }

  @Output() breakdownsInSolution = new EventEmitter<boolean>();
  @Output() reloadSolution = new EventEmitter<boolean>();

  ascendant: boolean = true;
  breakdownsInlist: boolean = false;
  breakpointsForDiscount: { [key: string]: string } = {
    '1024px': '50vw',
    '768px': '60vw',
    '560px': '90vw'
  };
  breakpointsForDistributeTotalValue: { [key: string]: string } = {
    '1024px': '50vw',
    '768px': '60vw',
    '560px': '90vw'
  };
  ascendantArticle: boolean = true;
  dataArticlesPriceList: PagedResponseModel<any> = new PagedResponseModel<any>();
  disableButtons: boolean = false;
  columnSort: string | null = null;
  columnSortArticle: string | null = null;
  breakdownContract: BreakdownModel = new BreakdownModel();
  breakdownData: PagedResponseModel<QuotationBreakdownCaptureTableModel> = new PagedResponseModel<QuotationBreakdownCaptureTableModel>();
  breakdownHeader: ColumnResponseModel[] = [];
  checkboxActions: CheckBoxAction[] = [
    {
      label: 'Eliminar',
      icon: 'pi pi-trash',
      color: ActionColor.DANGER,
      action: 'bulk-delete'
    },
  ];
  clearSelectionTrigger: number = 0;
  isFormView: boolean = false;
  filtersArticle: ColumnResponseModel[] = [];
  headerArticle: ColumnResponseModel[] = [];
  usesPriceList: boolean = true;
  inputsForArticlesSelection$ = new BehaviorSubject<any>({
    headers: [],
    data: [],
    showCheckbox: false,
    showRecover: true,
    isMultipleSelect: true,
    filters: [],
    actions: []
  });
  inputsForDistributeTotalValue$ = new BehaviorSubject<any>({
    quotationSolutionModel: QuotationDetailModel
  });
  inputsForApplyDiscount$ = new BehaviorSubject<any>({
    quotationSolutionModel: QuotationDetailModel,
    rateDiscountMax: 0
  });
  output$ = new Subject<any>();
  outputDistributeTotalValue$ = new Subject<any>();
  outputApplyDiscount$ = new Subject<any>();
  limit: number = 10;
  limitArticle: number = 5;
  page: number = 1;
  pageArticle: number = 1;
  previousSort: { field: string; isAscsendant: number };
  priceListId: number = 0;
  quotationTypeId: number = 0;
  quotationSolution: QuotationDetailModel = new QuotationDetailModel();
  quotationSolutionId: number = 0;
  quotationContract: QuotationModel = new QuotationModel();
  subscription: Subscription;
  tableActionsBreakdown: TableAction[] = [];

  componentTableSelection = CustomTableSelectComponent;
  componentDistributeTotalValue = DistributeTotalValueBreakdownComponent;
  componentApplyDiscount = ApplyDiscountBreakdownComponent;

  constructor(private breakdownService: BreakdownService,
    private confirmDialogService: ConfirmDialogService,
    private priceListDetailService: PriceListDetailService,
    private toastHandlerService: ToastHandlerService,
  ) { }

  async ngOnInit() {
    this.getColumnsForBreakdown();

    this.subscription = this.output$.subscribe(({ type, payload }) => {
      switch (type) {
        case 'onPageChange':
          this.onPageChangeArticle(payload);
          break;
        case 'onFilterChange':
          this.onFilterChange(payload);
          break;
        default:
          console.warn('Tipo de evento desconocido:', type);
      }
    });

    this.subscription = this.outputDistributeTotalValue$.subscribe(({ type }) => {
      switch (type) {
        case 'updateList':
          this.updateSolution();
          this.getAllBreakdownsByQuotationSolution();
          break;
        default:
          console.warn('Tipo de evento desconocido:', type);
      }
    });

    this.subscription = this.outputApplyDiscount$.subscribe(({ type }) => {
      switch (type) {
        case 'updateList':
          this.updateSolution();
          this.getAllBreakdownsByQuotationSolution();
          break;
        default:
          console.warn('Tipo de evento desconocido:', type);
      }
    });
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }


  changeSolution(changeSolution: QuotationDetailModel) {
    this.quotationSolution = changeSolution;
    this.quotationSolutionId = this.quotationSolution.quotationDetailId;
    if (this.quotationSolutionId != 0) {
      this.clearSelectionTrigger++;
      this.getAllBreakdownsByQuotationSolution();
    } else {
      this.breakdownData = new PagedResponseModel<QuotationBreakdownCaptureTableModel>();
    }
  }

  changeQuotation(change: QuotationModel) {
    if (change.quotationId != 0) {
      this.quotationContract = change;
      this.priceListId = change.priceListId as number;
      this.quotationTypeId = change.quotationTypeId;
      this.usesPriceList = change.quotationTypeId === QuotationTypesEnums.rental;
      // this.disabledDetail = change.quotationStateId != QuotationStateEnums.open;
      this.getColumnsArticle();
    }
  }

  changeVersionState(change: boolean) {
    this.disableButtons = change
    if (change) {
      this.tableActionsBreakdown = [];
    } else {
      this.tableActionsBreakdown = [
        {
          label: 'Editar',
          icon: 'pi pi-pencil',
          action: 'edit'
        }
      ];
    }
  }

  async deleteBreakdown(selectedIds: number[]) {
    if (selectedIds.length === 0) return;

    const accepted = await this.confirmDialogService.confirm('¿Realmente desea eliminar el despiece de la solución?');
    if (accepted) {
      try {
        await firstValueFrom(this.breakdownService.deleteSomeDetails(selectedIds));
        this.toastHandlerService.showToast('success', 'El despiece fue eliminado exitosamente.', 'Atención');
        this.updateSolution();
        this.clearSelectionTrigger++;
        this.getAllBreakdownsByQuotationSolution();

        this.breakdownContract = new BreakdownModel();
      } catch (error) {
        console.error('Error al eliminar el despiece de la solución.', error);
      }
    }
  }

  async getAllBreakdownsByQuotationSolution() {
    try {
      this.breakdownData = await firstValueFrom(this.breakdownService.getAllBreakdownsByQuotationForCapture(this.quotationSolution.quotationId, this.quotationSolution.quotationDetailId, this.page, this.limit, this.columnSort, this.ascendant));
      this.breakdownsInlist = this.breakdownData.items.length > 0
      this.breakdownsInSolution.emit(this.breakdownsInlist)
    } catch (error) {
      console.error('Error al buscar el despiece de la solución.', error);
    }
  }

  async getAllBreakdownsByQuotation() {
    try {
      this.dataArticlesPriceList = await firstValueFrom(
        this.priceListDetailService.getAllBreakdownsByQuotationForCapture(this.priceListId, this.quotationSolutionId, this.pageArticle, this.limitArticle, this.columnSortArticle, this.ascendantArticle, this.filtersArticle));
      this.updateInputs();
    } catch (error) {
      console.error('Error al obtener la lista de los artículos', error);
    }
  }

  async getColumnsForBreakdown() {
    try {
      if (this.breakdownHeader.length === 0) {
        this.breakdownHeader = await firstValueFrom(this.breakdownService.getColumnsForBreakdownCapture());
      }
    } catch (error) {
      console.error('Error al buscar las columnas para la consulta despiece.', error);
    }
  }

  async getColumnsArticle() {
    try {
      this.headerArticle = await firstValueFrom(this.priceListDetailService.getColumnsFoArticlesWithPriceByQuotation(this.quotationTypeId));
    } catch (error) {
      console.error('Error al buscar las columnas para la selección de artículos.', error);
    }
  }

  getFormView(isFormView: boolean) {
    this.isFormView = isFormView;
  }

  private buildBreakdown(item: any): BreakdownModel {
    const breakdown = new BreakdownModel();
    breakdown.quotationDetailId = this.quotationSolutionId;
    breakdown.quotationId = this.quotationContract.quotationId;
    breakdown.articleId = parseInt(item.articleId);
    if (this.usesPriceList) {
      if (item.UnitValue > 0) {
        breakdown.unitValue = item.baseUnitValue;
        breakdown.discountRate = item.rateDiscount;
        breakdown.clientValue = item.unitValue;
      } else {
        breakdown.unitValue = item.baseUnitValueList;
        breakdown.discountRate = item.rateDiscountList;
        breakdown.clientValue = item.unitValueList;
      }
      breakdown.clientValueList = item.unitValueList;
    } else {
      if ([QuotationTypesEnums.newSale, QuotationTypesEnums.maintenance].includes(this.quotationTypeId)) {
        breakdown.unitValue = item.saleValue;
        breakdown.clientValue = item.saleValue;
        breakdown.clientValueList = item.saleValue;
      } else {
        breakdown.unitValue = item.mayorRepairValue;
        breakdown.clientValue = item.mayorRepairValue;
        breakdown.clientValueList = item.mayorRepairValue;
      }
      breakdown.discountRate = 0;
    }
    return breakdown;
  }

  async handleSelectedItem(selectedItem: any[]) {
    if (!selectedItem?.length) return;
    const breakdowns = selectedItem.map(item => this.buildBreakdown(item));
    if (breakdowns.length > 1) {
      await firstValueFrom(
        this.breakdownService.createMultipleBreakdowns(breakdowns, this.quotationSolutionId)
      );
      this.toastHandlerService.showToast('success', 'El despiece fue creado exitosamente', '');
      this.getAllBreakdownsByQuotationSolution();
      this.updateSolution();
    } else {
      this.breakdownContract = breakdowns[0];
      this.getFormView(true);
    }
  }

  async onAction(event: { action: string, item?: QuotationBreakdownCaptureTableModel, selectedItems?: number[] }) {
    if (event.action === 'edit') {
      const response = await firstValueFrom(this.breakdownService.getBreakdownById(event.item!.breakdownId));
      if (response)
        this.breakdownContract = response;
      this.getFormView(true);
    }
    if (event.action === 'bulk-delete' && event.selectedItems) {
      this.deleteBreakdown(event.selectedItems);
    }
  }

  async onFilterChange(event: { filters: any }) {
    const filters = event.filters
      .map((value: any, index: any): any => ({ value, index }))
      .sort((a: any, b: any) => b.index - a.index)
      .map((item: any) => item.value);

    this.filtersArticle = this.removeDuplicates(filters);
    this.filtersArticle.forEach((filter: any) => this.processFilter(filter));
    this.updateInputs();
  }

  async onPageChange(event: { page: number; pageSize: number, sortField: string | undefined, sortOrder: number }) {
    this.page = event.page;
    this.limit = event.pageSize;
    this.columnSort = event.sortField || null;
    this.ascendant = event.sortOrder === 1;
    await this.getAllBreakdownsByQuotationSolution();
  }

  async onPageChangeArticle(event: { page: number; pageSize: number, sortField: string | undefined, sortOrder: number }) {
    this.pageArticle = event.page;
    this.limitArticle = event.pageSize;
    this.columnSortArticle = event.sortField || null;
    this.ascendantArticle = event.sortOrder === 1;
    this.getAllBreakdownsByQuotation();
  }

  async openArticleSelectionModal() {
    this.filtersArticle = [];
    await Promise.all([
      this.getColumnsArticle(),
      this.getAllBreakdownsByQuotation()]
    );
    this.updateInputs();
    this.articleSelectionModalComponent && this.articleSelectionModalComponent.show();
  }

  async openApplyDiscountModal() {
    this.updateApplyDiscountInputs();
    this.applyDiscountModalComponent && this.applyDiscountModalComponent.show();
  }

  async openDistributeTotalValueModal() {
    this.updateDistributeTotalValueInputs();
    this.distributeTotalValueModalComponent && this.distributeTotalValueModalComponent.show();
  }

  private removeDuplicates(filters: any[]): any[] {
    return filters.filter((value, index, self) =>
      index === self.findIndex((t: any) => t.propertyName === value.propertyName)
    );
  }

  private processFilter(filter: any): void {
    const { propertyName, valueFilter, valueAlterFilter } = filter;
    if (valueFilter === null || valueFilter === undefined || valueFilter === '' || valueFilter === 0) {
      this.filtersArticle = this.filtersArticle.filter(f => f.propertyName !== propertyName);
    } else {
      const existingFilter = this.filtersArticle.find(f => f.propertyName === propertyName);
      if (existingFilter) {
        existingFilter.valueFilter = valueFilter;
        existingFilter.valueAlterFilter = valueAlterFilter;
      }
    }
  }

  updateInputs() {
    this.inputsForArticlesSelection$.next({
      headers: this.headerArticle,
      data: this.dataArticlesPriceList,
      showCheckbox: true,
      showRecover: true,
      isMultipleSelect: true,
      limitPaginator: true,
      filters: this.filtersArticle,
      actions: [
        {
          label: 'Imágenes',
          icon: 'pi pi-image',
          action: 'view-image'
        }
      ]
    });
  }

  updateDistributeTotalValueInputs() {
    this.inputsForDistributeTotalValue$.next({
      quotationSolutionModel: this.quotationSolution
    });
  }

  updateApplyDiscountInputs() {
    this.inputsForApplyDiscount$.next({
      quotationSolutionModel: this.quotationSolution,
      rateDiscountMax: this.userAuthenticated.rateDiscountMax
    });
  }


  updateSolution() {
    this.reloadSolution.emit(true);
  }
}
